import React, { useEffect, useMemo } from "react";

import { Paper, Tab, Tabs } from "@material-ui/core";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";

import { getSettingsRoute } from "lib/navigation";

import history from "appHistory";
import { useGetSelectedTabFromRoute } from "hooks/useGetSelectedTabFromRoute";
import { LabelSettings } from "containers/Settings/Labels";
import { BusinessLabels } from "containers/Settings/Labels/BusinessLabels";

export const LabelsSettings = () => {
  const match = useRouteMatch();

  const tabs = useMemo(
    () => [
      {
        label: "Sale Lot Labels",
        component: LabelSettings,
      },
      {
        label: "Business Labels",
        component: BusinessLabels,
      },
    ],
    [],
  );

  const currentTab = useGetSelectedTabFromRoute(tabs);

  useEffect(() => {
    if (!currentTab && tabs[0]?.label) {
      history.push(getSettingsRoute(`Labels/${tabs[0].label}`));
    }
  }, [currentTab, match.path, tabs]);

  return (
    <>
      <Paper>
        <Tabs value={currentTab} variant="scrollable">
          {tabs.map(({ label }) => (
            <Tab
              label={label}
              key={label}
              value={label}
              data-tour={label}
              component={Link}
              to={label}
            />
          ))}
        </Tabs>
      </Paper>

      <Switch>
        {tabs.map(({ label, component }) => (
          <Route
            key={label}
            path={`${match.path}${label}`}
            component={component}
          />
        ))}
      </Switch>
    </>
  );
};
